import * as _ from "lodash";
import { Container } from "unstated";
import moment from "moment";

class MasterContainer extends Container {
  constructor() {
    super();
    this.state = {
      selectedRoute: null,
    };
  }

  getSelectedBar = () => {
    return this.state.selectedRoute;
  };

  setSelectedBar = (e) => {
    if ((String(e)?.toLowerCase?.() ?? "") == "/about") {
      this.setState({ selectedRoute: "/about" });
    } else if ((String(e)?.toLowerCase?.() ?? "") == "/contact") {
      this.setState({ selectedRoute: "/contact" });
    } else {
      this.setState({ selectedRoute: "/home" });
    }
  };
}

export default MasterContainer;
